import type React from 'react';
import { Box, Heading, List } from '@zillow/constellation-10';
import Modal from '@common/components/ConstellationV10Modal';
import userPersonas from '@common/constants/userPersonas';
import DebouncedButton from '@common/components/ConstellationDebouncedButton';
import IreneOnboardingCSEvents from '@rental-manager/tracking/OnboardingClickStreamEvents';
import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

interface Props {
  onSubmit: () => void;
  onClose: () => void;
  user: ZrmClickstreamUser;
  currentProperty: ZrmClickstreamListing;
}

const Checklist: React.FC<Props> = ({ onSubmit, onClose, user, currentProperty }) => {
  const handleSubmit = (): void => {
    IreneOnboardingCSEvents.emitContinueFromChecklistPageEvent({ currentProperty, user });
    return onSubmit();
  };

  const handleClose = (): void => {
    IreneOnboardingCSEvents.emitExitFromOnboardingFlowEvent({
      currentProperty,
      user,
      triggerObject: 'checklist',
    });
    onClose();
  };

  return (
    <Modal
      persona={userPersonas.LANDLORD}
      onRequestClose={handleClose}
      header="Payment setup"
      body={
        <Box>
          <Heading level={3} textStyle="body-lg-bold">
            Here’s what you’ll need
          </Heading>
          <List.Root appearance="bullet">
            <List.Item>Bank account info for where you’d like to receive payments</List.Item>
            <List.Item>Amounts for the monthly rent and any move-in charges</List.Item>
            <List.Item>Basic details about your renter</List.Item>
            <List.Item>
              Your Social Security number (SSN), a physical mailing address, and an Employer Identification Number (EIN)
              if your rental is owned by a business
            </List.Item>
          </List.Root>
        </Box>
      }
      footer={<DebouncedButton onClick={handleSubmit}>Ok, got it</DebouncedButton>}
    />
  );
};

export default Checklist;
